export const danfossDeepRed = "#B6000F";
export const danfossDeepRed80 = "#C54A34";
export const danfossDeepRed60 = "#D3785E";
export const danfossRed = "#E2000F";
export const white = "#FFFFFF";
export const black = "#000000";
export const black80 = "#575756";
export const black60 = "#878786";
export const black40 = "#B0B0B1";
export const black20 = "#D8D8D9";
export const black10 = "#EBEBEB";
export const grey = "#869098";
export const grey80 = "#9DA7AF";
export const grey60 = "#B4BCC3";
export const grey40 = "#CCD3D8";
export const grey20 = "#E5E8EB";
export const grey10 = "#F4F4F4";
export const danfossWebDarkGrey = "#303030";
export const danfossWebDimGrey = "#484848";
export const danfossWebGrey = "#686868";
export const danfossWebMediumGrey = "#969696";
export const danfossWebLightGrey = "#BFBEBE";
export const amber = "#FE8A01";
export const green = "#1AC632";
export const blue = "#46B9F3";
export const purple = "#9B58B5";
export const darkBlue = "#34495E";
export const deepBlue = "#1F61A3";
export const pink = "#E30177";
export const yellow = "#F1C40F";
export const turquoise = "#1BBC9B";